import { useEffect } from "react";

import ErrorSubType from "@constants/ErrorSubType";
import { reportError } from "@utilities/error-handler";
import { isDebugMode } from "@utilities/helper";

export const trackPageEvent = (
  action: string,
  category: Gtag.EventNames,
): void => {
  if (typeof window !== "undefined" && window.gtag) {
    try {
      window.gtag("event", action, {
        event_category: category,
      });
    } catch (error) {
      reportError(error, ErrorSubType.GA_EXCEPTION);
    }
    if (isDebugMode()) {
      console.log("Google Analytic:", action, category);
    }
  }
};

export const usePageEvent = (
  action: string,
  category: Gtag.EventNames = "page_view",
): void => {
  useEffect(() => {
    if (action) {
      trackPageEvent(action, category);
    }
  }, [action, category]);
};
